import { render, staticRenderFns } from "./DeFiTransferCategorization.vue?vue&type=template&id=39b05bb9&"
import script from "./DeFiTransferCategorization.vue?vue&type=script&lang=js&"
export * from "./DeFiTransferCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports